import { getDemoPreviews } from './get-demo-previews';
import { shouldShowField } from './should-show-field';
import { validateForm } from './validate-form';
import { applyFieldLogic } from './apply-field-logic';
import { getDynamicOptions } from './get-dynamic-options';

export const getMacroSacaTuTarjetaHelpers = () => ({
  shouldShowField,
  validateForm,
  getDemoPreviews,
  applyFieldLogic,
  getDynamicOptions
});

export { shouldShowField, validateForm, getDemoPreviews, applyFieldLogic, getDynamicOptions };
